export default {
  UPDATE: 'update',
  EXCLUDE: 'exclude',
  ADD: 'add',
};
